module.exports = __webpack_public_path__ + "img/screen_lock_rotation.a7eb17d7.svg";